import { BaseAgent } from "../../agents/BaseAgent";

export class RTVisualizer {
  public active: boolean = true;
  constructor(public agent: BaseAgent) { }
  public setActive(active: boolean) {
    this.active = active;
  }
}